import { Utensils, ShoppingBag, Scissors, Stethoscope, Globe, Car, Dumbbell, Coffee } from "lucide-react";
import { Reveal, Eyebrow } from "@/components/site/Motion";
import { QuoteButton } from "@/components/site/Nav";

const STEPS = [
  ["Tell us about your business", "A quick, no-obligation quote. Takes about a minute."],
  ["Meet your account manager", "They review your setup and find the best way to eliminate your fees."],
  ["Get set up and equipped", "We handle the paperwork. Qualifying merchants get free equipment."],
  ["Grow with support", "Tech support and customer service whenever you need it."],
];

const INDUSTRIES = [[Utensils, "Restaurants"], [Coffee, "Cafes"], [ShoppingBag, "Retail"], [Scissors, "Salons & spas"], [Stethoscope, "Healthcare"], [Car, "Auto services"], [Dumbbell, "Fitness"], [Globe, "E-commerce"]];

export const Steps = () => (
  <section id="how-it-works" className="bg-white px-4 py-24 sm:px-6 lg:px-12 lg:py-32" data-testid="steps-section">
    <div className="mx-auto grid max-w-7xl gap-14 lg:grid-cols-12">
      <div className="lg:col-span-5">
        <div className="lg:sticky lg:top-32">
          <Reveal>
            <Eyebrow>How it works</Eyebrow>
            <h2 className="mt-4 font-display text-4xl font-extrabold leading-[1.02] tracking-tight sm:text-5xl lg:text-6xl">Switching is <span className="text-emerald-600">easier</span> than you think.</h2>
            <p className="mt-6 max-w-md text-emerald-950/75">Four simple steps and you're processing with a partner that works for you.</p>
            <QuoteButton testid="steps-quote-btn" dark className="mt-8" />
          </Reveal>
        </div>
      </div>
      <ol className="space-y-4 lg:col-span-7">
        {STEPS.map(([t, d], i) => (
          <Reveal as="li" key={t} delay={i * 0.06}>
            <div className="group flex gap-6 rounded-3xl border border-emerald-900/10 p-7 transition-[background-color,border-color] duration-500 hover:border-lime-400 hover:bg-[#EAF3FF] sm:p-9" data-testid={`step-${i}`}>
              <span className="font-display text-5xl font-extrabold leading-none text-lime-500 transition-transform duration-500 group-hover:-translate-y-1 sm:text-6xl">0{i + 1}</span>
              <div>
                <p className="font-display text-2xl font-extrabold tracking-tight">{t}</p>
                <p className="mt-2 text-emerald-950/75">{d}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);

export const Industries = () => (
  <section className="bg-[#EAF3FF] px-4 py-20 sm:px-6 lg:px-12" data-testid="industries-section">
    <div className="mx-auto max-w-7xl">
      <Reveal className="flex flex-col justify-between gap-4 md:flex-row md:items-end">
        <div>
          <Eyebrow>Industries</Eyebrow>
          <h2 className="mt-4 font-display text-3xl font-extrabold tracking-tight sm:text-4xl">Built for businesses like yours.</h2>
        </div>
      </Reveal>
      <div className="mt-10 grid grid-cols-2 gap-3 sm:grid-cols-4">
        {INDUSTRIES.map(([I, l], i) => (
          <Reveal key={l} delay={i * 0.04}>
            <div className="group flex items-center gap-3 rounded-2xl border border-emerald-900/10 bg-white px-5 py-5 transition-[background-color,transform] duration-300 hover:-translate-y-1 hover:bg-[#0B2A6F]" data-testid={`industry-${i}`}>
              <I className="h-5 w-5 shrink-0 text-emerald-600 group-hover:text-lime-300" />
              <span className="font-semibold text-[#050B1F] group-hover:text-white">{l}</span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
